import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import Config from "config";
import { toast } from "react-toastify";
import {
  setValueDocs,
  setCategorieDocs,
  setTypeDocs,
  setCurrentPageDocs,
  setOrderDocs,
  setSortFieldDocs,
  setAnneeDocs,
} from "../../store/actions";
import FilePreview from "components/Common/previewFile";
import { useSelector, useDispatch } from "react-redux";

import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import useDebounce from "../Investor/useDebounce";
import { useNavigate } from "react-router-dom";
import LastModificationAlert from "components/Common/Alert";
import {
  Col,
  Row,
  Card,
  CardBody,
  Modal,
  ModalBody,
  ModalHeader,
  Form,
  Label,
  Input,
} from "reactstrap";
function MesDocuments() {
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  const dispatch = useDispatch();
  const history = useNavigate();
  const [loading, setLoading] = useState(true);
  const [documents, setDocumentsData] = useState([]);
  const token = localStorage.getItem("auth_token_" + api);
  const [redirectToLoginPage, setRedirect] = useState(false);
  const [wait, setWait] = useState(400);
  const [modal, setModal] = useState(false);
  const [reload, setReload] = useState(true);

  const [modal_1, setModal_1] = useState(false);
  const toggleModal1 = async () => {
    if (!modal_1) {
      // on charge les catégories seulement à l'ouverture du modal
      await getCategorieDocument();
    }
    setModal_1(!modal_1);
  };
  const [docData, setDocData] = useState();
  const [docId, setDocId] = useState("");
  const [selectedCategories, setSelectedCategorie] = useState();
  const handleCategorieChange = (e) => {
    setSelectedCategorie(e);
  };

  const [selectedType, setSelectedType] = useState();
  const handleTypeChange = (e) => {
    setSelectedType(e);
  };
  const [selectedNom, setSelectedNom] = useState();
  const [selectedFichier, setSelectedFichier] = useState();

  const handleFileChange = (event) => {
    const newFile = event.target.files[0]; // Récupère le nouveau fichier
    if (newFile) {
      setSelectedFichier(newFile);
    } else {
      setSelectedFichier(null);
      console.log("Aucun fichier sélectionné");
    }
  };
  const [selectedComment, setSelectedComment] = useState("");
  // New
  const [newCategories, setNewCategorie] = useState("");
  const [newType, setNewType] = useState("");
  const [newNom, setNewNom] = useState("");
  const [newFichier, setNewFichier] = useState("");
  const [newComment, setNewComment] = useState("");

  const handleNewCategorieChange = (e) => {
    setNewCategorie(e);
  };

  const handleNewTypeChange = (e) => {
    setNewType(e);
  };

  const handleNomChange = (e) => {
    setNewNom(e.target.value);
  };

  const handleNewFileChange = (event) => {
    const newFile = event.target.files[0]; // Récupère le nouveau fichier
    if (newFile) {
      setNewFichier(newFile);
    } else {
      setNewFichier(null);
      console.log("Aucun fichier sélectionné");
    }
  };
  const handleNewSubmit = async () => {
    if (newCategories?.value == null || "") {
      toast.error("Catégorie ne peut pas être vide");
    } else if (newType?.value == null || "") {
      toast.error("Type ne peut pas être vide");
    } else if (newFichier == null || "") {
      toast.error("Merci de renseigner un fichier");
    } else {
      document.getElementById("create_button").disabled = true;
      const formData = new FormData();

      formData.append("fichier", newFichier);
      formData.append("categories_document_id", newCategories?.value);
      formData.append("types_document_id", newType?.value);
      formData.append("nom", newNom);
      formData.append("commentaires", newComment);
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/mes_documents/`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: formData,
          }
        );
        if (response.ok) {
          console.log("PATCH request successful");
          toast.success("Document Ajouté");
          setModal_1(false);
          setReload(false);
        } else {
          document.getElementById("create_button").disabled = false;
          console.error("PATCH request failed");
          const responseData = await response.json();
          if (responseData && responseData.contact_document_validation) {
            // Si le champ "societe_validation" est présent dans la réponse JSON
            const errors = responseData.contact_document_validation;
            errors.forEach((error) => {
              toast.error(error);
            });
          } else {
            toast.error("Une erreur s'est produite");
          }
        }
      } catch (error) {
        console.error("An error occurred", error);
        toast.error("Une erreur s'est produite");
      }
    }
  };
  const handleUpdateSubmit = async () => {
    if (selectedCategories?.value == null || "") {
      toast.error("Catégorie ne peut pas être vide");
    } else if (selectedType?.value == null || "") {
      toast.error("Type ne peut pas être vide");
    } else {
      try {
        setLoading(true);
        const formData = new FormData();
        formData.append("id", docId);

        formData.append("fichier", selectedFichier);
        formData.append("categories_document_id", selectedCategories?.value);
        formData.append("types_document_id", selectedType?.value);
        formData.append("nom", selectedNom);
        formData.append("commentaires", selectedComment);
        const response = await fetch(
          `https://www.fluxod.com/${api}/mes_documents/${docId}`,
          {
            method: "PATCH",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: formData,
          }
        );

        if (response.ok) {
          console.log("PATCH request successful");
          toast.success("Document Modifié");
          setReload(false);
          setLoading(false);
        } else {
          console.error("PATCH request failed");
          const responseData = await response.json();
          setLoading(false);
          if (responseData && responseData.contact_document_validation) {
            // Si le champ "societe_validation" est présent dans la réponse JSON
            const errors = responseData.contact_document_validation[0];
            errors.forEach((error) => {
              toast.error(error);
            });
          } else {
            toast.error("Une erreur s'est produite");
          }
        }
      } catch (error) {
        console.error("An error occurred", error);
        toast.error("Une erreur s'est produite");
      }
    }
  };
  const getDocumentDetail = async (docId) => {
    try {
      // charger les catégories et types pour le modal
      await getCategorieDocument();
      await fetch(`https://www.fluxod.com/${api}/mes_documents/${docId}/edit`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setDocData(data);
          setSelectedCategorie(
            data?.detail_contact_document["Identification du documents"][
              "Catégorie"
            ]
          );
          setSelectedType(
            data?.detail_contact_document["Identification du documents"]["Type"]
          );
          setSelectedNom(
            data?.detail_contact_document["Identification du documents"]["Nom"]
          );
          setSelectedFichier(
            data?.detail_contact_document["Identification du documents"][
              "Fichier"
            ]
          );
          setSelectedComment(
            data?.detail_contact_document["Identification du documents"]
              .Commentaires
          );
          setModal(true);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const [categorieData, setCategorieData] = useState({ data: [] });
  const renderCategorieOptions = () => {
    return [
      {
        options: categorieData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const getCategorieDocument = async () => {
    try {
      await fetch(
        `https://www.fluxod.com/${api}/mes_documents/categories_documents`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setCategorieData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const [typeDocData, setTypeDocData] = useState({ data: [] });
  const renderTypeDocOptions = () => {
    return [
      {
        options: typeDocData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const getTypeDoc = async (docId) => {
    try {
      await fetch(
        `https://www.fluxod.com/${api}/mes_documents/types_documents?id=${docId}&categories_document_id=${
          selectedCategories?.value || newCategories?.value
        }`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setTypeDocData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };

  // Pagination

  const currentPage = useSelector(
    (state) => state.FiltreMesDocuments.currentPage
  );
  const itemsPerPage = 20; // Limite d'affichage par page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  //Recherche
  const value = useSelector((state) => state.FiltreMesDocuments.value);

  const categorie = useSelector((state) => state.FiltreMesDocuments.categorie);
  const type = useSelector((state) => state.FiltreMesDocuments.type);

  const annee = useSelector((state) => state.FiltreMesDocuments.annee);
  const [hasSetDefaultYear, setHasSetDefaultYear] = useState(false);

  // calculer l'annee_id basé sur l'année actuelle (2026 = 27, 2027 = 28, etc.)
  const getCurrentAnneeId = () => {
    const currentYear = new Date().getFullYear();
    return currentYear - 1999; // 2026-1999 = 27
  };

  const debounceSearch = useDebounce(value, 500);

  // Triage
  const handleSorting = async (sortField, sortOrder) => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/mes_documents?page=${currentPage}&sort_by=${sortField}_${sortOrder}&key=${debounceSearch}&types_document_id=${type}&categories_document_id=${categorie}&annee_id=${annee}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const newData = await response.json();
      setDocumentsData(newData);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };
  //Thead
  const sortField = useSelector((state) => state.FiltreMesDocuments.sortField);
  const order = useSelector((state) => state.FiltreMesDocuments.order);
  const [isSorting, setIsSorting] = useState(false);
  const handleSortingChange = (accessor) => {
    dispatch(setCurrentPageDocs(1));
    setIsSorting(true);
    const sortOrder =
      accessor === sortField && order === "asc" ? "desc" : "asc";

    dispatch(setSortFieldDocs(accessor));
    dispatch(setOrderDocs(sortOrder));

    handleSorting(accessor, sortOrder); // Appel à la fonction de tri
    setIsSorting(false);
  };

  //meta title
  document.title = "Mes documents | DOM COM";

  useEffect(() => {
    if (redirectToLoginPage == true) {
      localStorage.removeItem("auth_token_" + api);
      localStorage.removeItem("authUser_" + api);
      localStorage.removeItem("sideBar_" + api);
      history(`${backUrl}/login`);
      window.location.reload(false);
    }
    if (localStorage.getItem("key") === "true") {
      toast.success("Mise à jour réussie");
      localStorage.setItem("key", "false");
    }
  }, [redirectToLoginPage, history]);
  //page change
  const fetchPage = async (currentPage) => {
    try {
      const res = await fetch(
        `https://www.fluxod.com/${api}/mes_documents?page=${currentPage}&sort_by=${sortField}_${order}&key=${debounceSearch}&types_document_id=${type}&categories_document_id=${categorie}&annee_id=${annee}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await res.json();
      return data;
    } catch (error) {
      console.error("Error fetching page: ", error);
    }
  };

  const handlePageChange = async (data) => {
    let currentPage = data.selected + 1;
    const getData = await fetchPage(currentPage);
    dispatch(setCurrentPageDocs(currentPage));
    setDocumentsData(getData);
  };
  // Filtre

  // Fonction pour mettre à jour l'état du filtre et appeler la mise à jour des paramètres accumulés
  const handleFilterChange = (accessor, value) => {
    const updatedFilters = documents.filters.map((filter) => {
      if (filter.accessor === accessor) {
        return {
          ...filter,
          value: value,
        };
      }
      return filter;
    });

    setDocumentsData((prevData) => ({
      ...prevData,
      filters: updatedFilters,
    }));

    // Mettre à jour les paramètres de filtre
  };

  const renderFilters = () => {

    return (
      <>
        {!loading ? (
          <>
            {documents?.filters?.map((filter, index) => {
              switch (filter.accessor) {
                case "key":
                  return (
                    <>
                      <Col md={2} className="mb-1" key={index}>
                        <input
                          defaultValue={value}
                          className="form-control mb-3 mb-xxl-0"
                          type="text"
                          placeholder={filter.label}
                          onChange={(e) => {
                            dispatch(setValueDocs(e.target.value));
                            dispatch(setCurrentPageDocs(1));
                            handleFilterChange(filter.accessor, value);
                          }}
                        />
                      </Col>
                      {documents?.filters?.find((f) => f.label === "Année")
                        ?.list?.length > 0 && (
                        <Col md={2} className="mb-1" key={"select-annee"}>
                          <select
                            className="form-control mb-3 mb-xxl-0"
                            value={annee}
                            onChange={(e) => {
                              dispatch(setAnneeDocs(e.target.value));
                              dispatch(setCurrentPageDocs(1));
                            }}
                          >
                            <option value="">Année</option>
                            {documents.filters
                              .find((f) => f.label === "Année")
                              .list.map((item, itemIndex) => (
                                <option key={itemIndex} value={item.id}>
                                  {item.label}
                                </option>
                              ))}
                          </select>
                        </Col>
                      )}
                    </>
                  );
                case "categories_document_id":
                  return (
                    <Col md={2} className="mb-1" key={index}>
                      <select
                        defaultValue={categorie}
                        className="form-control mb-3 mb-xxl-0"
                        onChange={(e) => {
                          dispatch(setCategorieDocs(e.target.value)),
                            dispatch(setCurrentPageDocs(1));
                          handleFilterChange(filter.accessor, categorie);
                        }}
                      >
                        <option value="">{filter.label}</option>
                        {filter.list.map((item, itemIndex) => (
                          <option key={itemIndex} value={item.id}>
                            {item.label}
                          </option>
                        ))}
                      </select>
                    </Col>
                  );
                case "types_document_id":
                  return (
                    <Col md={2} className="mb-1" key={index}>
                      <select
                        defaultValue={type}
                        className="form-control mb-3 mb-xxl-0"
                        onChange={(e) => {
                          dispatch(setTypeDocs(e.target.value)),
                            dispatch(setCurrentPageDocs(1));
                          handleFilterChange(filter.accessor, type);
                        }}
                      >
                        <option value="">{filter.label}</option>
                        {filter.list.map((item, itemIndex) => (
                          <option key={itemIndex} value={item.id}>
                            {item.label}
                          </option>
                        ))}
                      </select>
                    </Col>
                  );
                default:
                  return null;
              }
            })}
          </>
        ) : (
          ""
        )}
      </>
    );
  };

  useEffect(() => {
    // définir l'année par défaut uniquement la première fois
    if (!hasSetDefaultYear && !annee) {
      const defaultAnneeId = getCurrentAnneeId();
      dispatch(setAnneeDocs(defaultAnneeId));
      setHasSetDefaultYear(true);
      return; // éviter le double appel
    }

    const handleFiltering = async () => {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/mes_documents?page=${currentPage}&sort_by=${sortField}_${order}&key=${debounceSearch}&types_document_id=${type}&categories_document_id=${categorie}&annee_id=${annee}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.status === 403) {
          navigate(`${backUrl}/forbidden`);
        }
        if (response.status === 500) {
          navigate(`${backUrl}/error`);
        }
        if (response.status === 203) {
          navigate(`${backUrl}/error404`);
        }
        dispatch(setCurrentPageDocs(1));
        const newData = await response.json();
        setDocumentsData(newData);
      } catch (error) {
        console.error("Erreur lors de la récupération des données : ", error);
      }
    };

    handleFiltering();
  }, [debounceSearch, categorie, type, reload, annee]);

  const lastId = localStorage.getItem("lastId");
  const previousPath = localStorage.getItem("previousPath_" + api);
  return (
    <React.Fragment>
      <div className="page-content">
        {previousPath == `${backUrl}/investissements/${lastId}/edit` ? (
          <LastModificationAlert path={"investissements"} />
        ) : null}
        <div className="container-fluid">
          <Row>
            <Col lg="12">
              <Modal isOpen={modal} toggle={() => setModal(!modal)}>
                <ModalHeader toggle={() => setModal(!modal)} tag="h4">
                  Détails du document
                </ModalHeader>
                <ModalBody>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      setModal(false);
                      handleUpdateSubmit();
                    }}
                  >
                    <Row>
                      <Col className="col-12">
                        <div className="mb-3">
                          <Label className="form-label">Investisseur</Label>
                          <Input
                            name="investisseur"
                            type="text"
                            placeholder="Nom de l'investisseur"
                            value={
                              docData?.detail_contact_document[
                                "Identification du documents"
                              ]["Investisseur"]
                            }
                            readOnly
                          />
                        </div>
                        <div className="mb-3">
                          <Label className="form-label">Catégorie</Label>
                          <Select
                            defaultValue={selectedCategories}
                            onChange={handleCategorieChange}
                            options={renderCategorieOptions()}
                            isClearable={true}
                            className="select2"
                            styles={{
                              control: (provided, state) => ({
                                ...provided,

                                boxShadow: state.isFocused ? "none" : "none", // Supprimer l'ombre lorsque le composant est en focus
                                "&:hover": {
                                  borderColor: "#555B21", // Couleur de la bordure au survol
                                },
                              }),
                              option: (provided, state) => ({
                                ...provided,
                                backgroundColor: state.isSelected
                                  ? "#555B21"
                                  : "white", // Couleur d'arrière-plan de l'option sélectionnée
                                color: state.isSelected ? "white" : "black", // Couleur du texte de l'option sélectionnée
                              }),
                            }}
                          />
                        </div>
                        <div className="mb-3">
                          <Label className="form-label">Type</Label>
                          <Select
                            defaultValue={selectedType}
                            onChange={handleTypeChange}
                            options={renderTypeDocOptions()}
                            isClearable={true}
                            className="select2"
                            styles={{
                              control: (provided, state) => ({
                                ...provided,

                                boxShadow: state.isFocused ? "none" : "none", // Supprimer l'ombre lorsque le composant est en focus
                                "&:hover": {
                                  borderColor: "#555B21", // Couleur de la bordure au survol
                                },
                              }),
                              option: (provided, state) => ({
                                ...provided,
                                backgroundColor: state.isSelected
                                  ? "#555B21"
                                  : "white", // Couleur d'arrière-plan de l'option sélectionnée
                                color: state.isSelected ? "white" : "black", // Couleur du texte de l'option sélectionnée
                              }),
                            }}
                          />
                        </div>
                        <div className="mb-3">
                          <Label className="form-label">Nom</Label>
                          <Input
                            name="nom"
                            type="text"
                            placeholder="Nom du document"
                            value={selectedNom}
                            onChange={(e) => setSelectedNom(e.target.value)}
                          />
                        </div>
                        <div className="mb-3">
                          <Label className="form-label">Commentaires</Label>
                          <Input
                            name="commentaire"
                            type="text"
                            placeholder="Commentaires"
                            value={selectedComment}
                            onChange={(e) => setSelectedComment(e.target.value)}
                          />
                        </div>
                        <div className="mb-3">
                          <Label className="form-label">Fichier :</Label>
                          <FilePreview
                            fileUrl={
                              docData?.detail_contact_document[
                                "Identification du documents"
                              ]["Fichier"]
                            }
                          />
                          <a
                            href={
                              docData?.detail_contact_document[
                                "Identification du documents"
                              ]["Fichier"]
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Télécharger le fichier
                          </a>
                          <input
                            type="file"
                            onChange={handleFileChange}
                            style={{
                              display: "block",
                              marginTop: "5px",
                            }}
                          />
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <div className="text-end">
                          <button
                            type="submit"
                            className="btn btn-success save-user"
                          >
                            Enregistrer
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </ModalBody>
              </Modal>
              <Modal isOpen={modal_1} toggle={() => setModal_1(!modal_1)}>
                <ModalHeader toggle={() => setModal_1(!modal_1)} tag="h4">
                  Nouveau document
                </ModalHeader>
                <ModalBody>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      handleNewSubmit();
                    }}
                  >
                    <Row>
                      <Col className="col-12">
                        <div className="mb-3">
                          <Label className="form-label">Investisseur</Label>
                          <Input
                            name="investisseur"
                            type="text"
                            placeholder="Nom de l'investisseur"
                            value={localStorage.getItem("authUser_" + api)}
                            readOnly
                          />
                        </div>
                        <div className="mb-3">
                          <Label className="form-label">Catégorie</Label>
                          <Select
                            defaultValue={newCategories}
                            onChange={handleNewCategorieChange}
                            options={renderCategorieOptions()}
                            isClearable={true}
                            className="select2"
                            styles={{
                              control: (provided, state) => ({
                                ...provided,

                                boxShadow: state.isFocused ? "none" : "none", // Supprimer l'ombre lorsque le composant est en focus
                                "&:hover": {
                                  borderColor: "#555B21", // Couleur de la bordure au survol
                                },
                              }),
                              option: (provided, state) => ({
                                ...provided,
                                backgroundColor: state.isSelected
                                  ? "#555B21"
                                  : "white", // Couleur d'arrière-plan de l'option sélectionnée
                                color: state.isSelected ? "white" : "black", // Couleur du texte de l'option sélectionnée
                              }),
                            }}
                          />
                        </div>
                        <div className="mb-3">
                          <Label className="form-label">Type</Label>
                          <Select
                            defaultValue={newType}
                            onChange={handleNewTypeChange}
                            options={renderTypeDocOptions()}
                            isClearable={true}
                            className="select2"
                            styles={{
                              control: (provided, state) => ({
                                ...provided,

                                boxShadow: state.isFocused ? "none" : "none", // Supprimer l'ombre lorsque le composant est en focus
                                "&:hover": {
                                  borderColor: "#555B21", // Couleur de la bordure au survol
                                },
                              }),
                              option: (provided, state) => ({
                                ...provided,
                                backgroundColor: state.isSelected
                                  ? "#555B21"
                                  : "white", // Couleur d'arrière-plan de l'option sélectionnée
                                color: state.isSelected ? "white" : "black", // Couleur du texte de l'option sélectionnée
                              }),
                            }}
                          />
                        </div>
                        <div className="mb-3">
                          <Label className="form-label">Nom</Label>
                          <Input
                            name="nom"
                            type="text"
                            placeholder="Nom du document"
                            value={newNom}
                            onChange={handleNomChange}
                          />
                        </div>
                        <div className="mb-3">
                          <Label className="form-label">Commentaires</Label>
                          <Input
                            name="commentaire"
                            type="text"
                            placeholder="Commentaires"
                            value={newComment}
                            onChange={(e) => setNewComment(e.target.value)}
                          />
                        </div>
                        <div className="mb-3">
                          <Label className="form-label">Fichier</Label>

                          <input
                            type="file"
                            onChange={handleNewFileChange}
                            style={{
                              display: "block",
                              marginTop: "5px",
                            }}
                          />
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <div className="text-end">
                          <button
                            type="submit"
                            id="create_button"
                            className="btn btn-success save-user"
                          >
                            Créer
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </ModalBody>
              </Modal>
              <Card>
                <CardBody className="border-bottom">
                  <div className="d-flex align-items-center">
                    <h5 className="mb-0 card-title text-primary flex-grow-1">
                      Mes documents ({loading ? "--" : documents?.total_records}
                      )
                    </h5>
                  </div>
                  <div className="d-flex justify-content-end">
                    <div className="d-flex align-items-end">
                      {documents?.can_add ? (
                        <Link
                          onClick={toggleModal1}
                          className="btn btn-sm btn-primary"
                        >
                          <i className="bx bx-plus"></i>Ajouter
                        </Link>
                      ) : null}
                    </div>
                  </div>
                </CardBody>
                <CardBody>
                  {!loading ? (
                    <>
                      <Row className="mb-3">{renderFilters()}</Row>
                    </>
                  ) : (
                    ""
                  )}

                  <div>
                    {!loading ? (
                      <>
                        {/* Affichage des documents */}
                        {documents?.data?.length > 0 ? (
                          <Row>
                            {documents.data.map((data, index) => (
                              <Col
                                lg={4}
                                md={6}
                                sm={12}
                                key={`document_${data.id}`}
                                className="mb-3"
                              >
                                <Row
                                  className="mx-0"
                                  style={{
                                    border: "1px solid #eee",
                                    borderRadius: "4px",
                                    padding: "10px 0",
                                    minHeight: "100px",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <Col
                                    xs={3}
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <div className="avatar-sm">
                                      <span className="avatar-title rounded-circle bg-primary-subtle text-primary font-size-24">
                                        <i className="bx bxs-file-doc" />
                                      </span>
                                    </div>
                                  </Col>
                                  <Col
                                    xs={7}
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <div style={{ width: "100%" }}>
                                      <a
                                        href={data.fichier}
                                        className="text-dark"
                                        style={{
                                          textDecoration: "none",
                                          display: "block",
                                        }}
                                        download
                                      >
                                        <h5
                                          className="font-size-13 mb-0"
                                          style={{
                                            paddingLeft: "10px",
                                            wordBreak: "break-word",
                                          }}
                                        >
                                          {data.nom}
                                        </h5>
                                      </a>
                                      {/* Année et date de création sous le nom */}
                                      <div
                                        style={{
                                          paddingLeft: "10px",
                                          fontSize: "11px",
                                          color: "#888",
                                          fontStyle: "italic",
                                          marginTop: "2px",
                                        }}
                                      >
                                        {data.annee && (
                                          <div>Année : {data.annee}</div>
                                        )}
                                        {data.cree_le && (
                                          <div>Créé le : {data.cree_le}</div>
                                        )}
                                      </div>
                                    </div>
                                  </Col>
                                  <Col
                                    xs={2}
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <a
                                      href={data.fichier}
                                      className="text-dark"
                                      download
                                    >
                                      <i
                                        className="bx bx-download h3 m-0"
                                        style={{
                                          fontSize: "1.5rem",
                                        }}
                                      />
                                    </a>
                                  </Col>
                                </Row>
                              </Col>
                            ))}
                          </Row>
                        ) : (
                          <div className="text-center p-4">
                            <p className="text-muted">
                              Aucun document disponible.
                            </p>
                          </div>
                        )}
                      </>
                    ) : (
                      <Spinners setLoading={setLoading} setWait={wait} />
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      <ToastContainer />
    </React.Fragment>
  );
}

export default MesDocuments;
